module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/avatar1-b74376780bb2899b3cfaea4b9ab934f8.png";